import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { DataService } from '../../../services/data.service';
import { LocaleService } from '../../../services/locale.service';

@Component({
  selector: 'app-pagamento-dettaglio',
  templateUrl: './pagamento-dettaglio.component.html',
  styleUrls: ['./pagamento-dettaglio.component.css']
})
export class PagamentoDettaglioComponent implements OnInit {
    @Input() data: any;
    @Input() writePermission: boolean = false;
    @Output() innerEvents = new EventEmitter();
    pagamento: any = null;

    constructor(private dataService: DataService, private formatter: LocaleService) { }

    ngOnInit() { }

    ngOnChanges(changes: any){
        console.debug('PAGAMENTO-DETTAGLIO|CHANGE', changes);
        if(changes.data){
            let currentPagamento = changes.data.currentValue.pagamento;
            let previousPagamento = changes.data.previousValue.pagamento;
            this.pagamento = currentPagamento;
            console.debug('PAGAMENTO-DETTAGLIO|CHANGE', previousPagamento, currentPagamento);
        }
    }

	hide(){
		let event: any = {
			hide : true
		}
		this.innerEvents.emit(event);
	}
}
